// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3rYTw","left":"InfoRow_left__1Ako_"};